import React from 'react'
import * as R from 'ramda'
import styled from 'styled-components'
import { Dispatch } from 'redux'
import { connect } from 'react-redux'
import { compose } from 'react-apollo'

import { LinkButton } from '../Styled/Shared'
import { Page } from '../Styled/Pages'

import { Store } from '../../reducers/index'
import { Action } from '../../actions/types'
import { selectCountry } from '../../actions/project'

import { getProjectLocation } from '../../reducers/project'
import { CountryType, withCountries } from '../Shared/CountryOptions'

import { getRedirectAfterLocationSelect } from '../../location_changes/conversionHelper'

/* stylelint-disable */
const LocationWrapper = styled(Page)``
/* stylelint-enable */

const WorldMapImage = require('./world-map.jpg')

const useHighlight = false
const useSelectColor = false

const CountrySelect = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  max-width: 1200px;
  padding-top: 80px;
  padding-bottom: 80px;

  .left  {
    float: left;
  }

  .right  {
    flex: 1 0 auto;
    float: right;
  }

  .right select {
    width: 100%;
    outline: none;
    border: 23px solid #aaa;
    appearance: none;
    border-radius: 0;
    padding: 15px;
    background-image: linear-gradient(45deg, transparent 50%, blue 50%),
      linear-gradient(135deg, blue 50%, transparent 50%);
    background-position: calc(100% - 20px) calc(1em + 7px),
      calc(100% - 15px) calc(1em + 7px), 100% 0;
    background-size: 5px 5px, 5px 5px, 4em 100%;
    background-repeat: no-repeat;
  }

  select.classic {
    background-position: calc(100% - 20px) calc(1em + 2px),
      calc(100% - 15px) calc(1em + 2px), 100% 0;
    background-size: 5px 5px, 5px 5px, 2.5em 2.5em;
    background-repeat: no-repeat;
  }

  .world-map {
    width: 800px;
    min-height: 450px; /* Reserve space so the layout doesn't jump around */
  }
`

const CountryOpt = ({ id, displayName }) => (
  <option value={id}>{displayName}</option>
)

const RemoveHighLight = () => {
  if (!useHighlight) {
    return
  }
  const cName = 'highlightedWMCountry'
  const elems = document.getElementsByClassName(cName)

  for (let indx = 0; indx < elems.length; indx++) {
    const el = elems.item(indx)
    if (el.classList) {
      el.classList.remove(cName)
    } else {
      // IE hack
      const SVGEl = el as SVGAElement
      SVGEl.className.baseVal = SVGEl.className.baseVal.replace(cName, ' ')
    }
  }
}

const RemoveSelect = () => {
  if (!useSelectColor) {
    return
  }
  const cName = 'selectedWMCountry'
  const elems = document.getElementsByClassName(cName)
  if (elems) {
    for (let indx = 0; indx < elems.length; indx++) {
      const el = elems.item(indx)
      if (el.classList) {
        el.classList.remove(cName)
      } else {
        const SVGEl = el as SVGAElement
        SVGEl.className.baseVal = SVGEl.className.baseVal.replace(cName, ' ')
      }
    }
  }
}

const HighLight = target => {
  if (!useHighlight) {
    return
  }
  const cName = 'highlightedWMCountry'
  if (target.classList) {
    target.classList.add(cName)
  } else {
    // IE workaround
    const el: SVGAElement = target as SVGAElement
    el.className.baseVal += (el.className.baseVal.length ? ' ' : '') + cName
  }
  const children = target.children
  if (children) {
    for (let indx = 0; indx < children.length; indx++) {
      HighLight(children.item(indx))
    }
  } else {
    for (let indx = 0; indx < target.length; indx++) {
      HighLight(target.item(indx))
    }
  }
}

const Select = target => {
  if (!useSelectColor) {
    return
  }
  const cName = 'selectedWMCountry'
  if (target.classList) {
    target.classList.add(cName)
  } else {
    // IE workaround
    const el: SVGAElement = target as SVGAElement
    el.className.baseVal += (el.className.baseVal.length ? ' ' : '') + cName
  }
  const children = target.children
  if (children) {
    for (let indx = 0; indx < children.length; indx++) {
      HighLight(children.item(indx))
    }
  }
}

const HighLightByName = country => {
  if (!useHighlight) {
    return
  }
  RemoveHighLight()
  const elems = document.getElementsByClassName(country.toLowerCase())
  for (let indx = 0; indx < elems.length; indx++) {
    HighLight(elems.item(indx))
  }
}

const SelectByName = country => {
  if (!useSelectColor) {
    return
  }
  RemoveSelect()
  RemoveHighLight()
  const elems = document.getElementsByClassName(country.toLowerCase())
  for (let indx = 0; indx < elems.length; indx++) {
    Select(elems.item(indx))
  }
}

type Props = {
  selectedCountry: string
  select: (country: string) => Action
  countries: CountryType[]
}

interface State {
  redirectUrl: string
}

class LocationSelect extends React.Component<Props, State> {
  lastHoverCountry = null

  readonly state = { redirectUrl: getRedirectAfterLocationSelect() }

  select = evt => {
    RemoveSelect()
    RemoveHighLight()
    evt.preventDefault()
    const country = this.props.countries
      .filter(c => c.id === evt.target.value)
      .map(c => c.id)[0]
    this.props.select(country)
    SelectByName(country)
    this.setState({
      redirectUrl: getRedirectAfterLocationSelect()
    })
  }

  findCountry = target => {
    const classes = target.className
      ? target.className.baseVal
        ? target.className.baseVal.split(' ')
        : [target.className]
      : []
    const countryClass = classes.filter(klass => klass.length === 2)
    const found = R.find(
      country => country.id.toLowerCase() === countryClass[0],
      this.props.countries || []
    )
    if (found) {
      return found
    }
    if (target.parentElement) {
      return this.findCountry(target.parentElement)
    }
  }

  onMouseOver = evt => {
    RemoveHighLight()
    evt.preventDefault()
    if (!evt.target) {
      return
    }
    const found = this.findCountry(evt.target)
    if (found && found.id !== this.lastHoverCountry) {
      this.lastHoverCountry = found.id
      HighLightByName(found.id)
    }
  }

  onClick = evt => {
    RemoveHighLight()
    RemoveSelect()
    evt.preventDefault()
    if (!evt.target) {
      return
    }
    const found = this.findCountry(evt.target)
    if (found) {
      SelectByName(found.id)
      this.props.select(found.id)
    }
  }

  render() {
    const { selectedCountry, countries = [] } = this.props

    return (
      <LocationWrapper>
        <div className="content">
          <h2>Please select your project location</h2>
          <h4>
            Your selection will not affect the calculation results. The design
            is based on plain Eurocode without any National annexes.
          </h4>

          <CountrySelect>
            <div className="left">
              <div
                className="world-map"
                onMouseOver={e => this.onMouseOver(e)}
                onClick={e => this.onClick(e)}
              >
                <img src={WorldMapImage} alt="" width="100%" />
              </div>
            </div>
            <div className="right">
              <select onChange={this.select} value={selectedCountry}>
                {countries.map((country, indx) => (
                  <CountryOpt key={indx} {...country} />
                ))}
              </select>
            </div>
          </CountrySelect>
          <LinkButton to={this.state.redirectUrl}>Next</LinkButton>
        </div>
      </LocationWrapper>
    )
  }
}

const mapStateToPros = (state: Store.Complete) => ({
  selectedCountry: getProjectLocation(state)
})

const mapDispatchToProps = (dispatch: Dispatch<Store.Complete>) => ({
  select: (country: string) => dispatch(selectCountry(country))
})

export default compose(
  withCountries,
  connect(
    mapStateToPros,
    mapDispatchToProps
  )
)(LocationSelect)



// WEBPACK FOOTER //
// ./src/Components/LocationSelect/index.tsx